/**
 * LamaIcon — placeholder RuaHQ mascot ("drama lama") for brand tiles and the
 * favicon-shaped slot in the sidebar. A proper designed mark should replace
 * this; until then the silhouette is good enough for nav + screenshots.
 */
import type { SVGProps } from 'react';

export interface LamaIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function LamaIcon({ size = 24, className, ...rest }: LamaIconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {/* ears */}
      <path d="M9 3.2 L10.1 6.6 L8.1 5.8 Z" />
      <path d="M14.6 3.2 L13.5 5.8 L15.5 6.6 Z" />
      {/* head + snout */}
      <path d="M11.8 5.6 c2.1 0 3.6 1.6 3.6 3.7 c0 1.1 -0.5 2 -1.3 2.6 c0.4 0.4 0.6 1 0.6 1.7 c0 1.6 -1.3 2.7 -2.9 2.7 c-1.6 0 -2.9 -1.1 -2.9 -2.7 c0 -0.7 0.2 -1.3 0.6 -1.7 c-0.8 -0.6 -1.3 -1.5 -1.3 -2.6 c0 -2.1 1.6 -3.7 3.6 -3.7 z" />
      {/* neck + body */}
      <path d="M9.7 16 c-0.9 1.4 -1.4 2.9 -1.4 4.6 L7 20.6 c0 -1.3 0.3 -2.5 0.8 -3.6 L7 16.6 l1.2 -0.9 c0.4 -0.3 1 -0.3 1.5 0.3 z M14 16.1 c0.5 1 0.8 2.2 0.8 3.5 v1 h-1.3 c0 -1.7 -0.5 -3.2 -1.4 -4.6 c0.5 -0.5 1.2 -0.5 1.6 -0.1 z" />
    </svg>
  );
}
